(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("vue"));
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["VueMicaSearch"] = factory(require("vue"));
	else
		root["VueMicaSearch"] = factory(root["Vue"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE__8bbf__) {
return 